module.exports = __webpack_public_path__ + "static/media/kidsmagazine_front.47e7337d.png";